// removed by extract-text-webpack-plugin
module.exports = {"success-message":"app-pages-VerifyEmailAlertRecipient-__VerifyEmailAlertRecipient___vyY9o","invalid-message":"app-pages-VerifyEmailAlertRecipient-__VerifyEmailAlertRecipient___13KOW"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/VerifyEmailAlertRecipient/VerifyEmailAlertRecipient.css
// module id = 2244
// module chunks = 0